export default {
    root: ({ props }) => ({
        class: [
            "relative",
            "overflow-hidden",
            "bg-stone-200 dark:bg-stone-700",
            "after:absolute after:top-0 after:left-0 after:right-0 after:bottom-0 after:content-['']",
            "after:w-full after:h-full after:bg-gradient-to-r",
            "after:from-transparent after:via-stone-50/40 dark:after:via-stone-600/40 after:to-transparent",
            "after:animate-shimmer",
            {
                "rounded-md": props.shape !== "circle",
                "rounded-full": props.shape === "circle",
            },
        ],
    }),
};
